// JointHolder/PAN/index.js
import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Modal } from "react-bootstrap";
import Button from "../../../components/Button";
import moment from "moment";
import DatePicker from "react-datepicker";
import InputMask from "react-input-mask";
import Title from "designs/v1/components/Title";
import InputTitle from "designs/v1/components/InputTitle";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  getStageScreen,
  setLoading as setReduxLoading,
} from "../../../../../redux";
import { getDgLocker } from "../../PanAddress/redux/action";
import { validateOnNumber } from "utils";
import { FaTimes } from "react-icons/fa";

const MainSchema = Yup.object().shape({
  panNumber: Yup.string()
    .matches(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/, "Invalid PAN Number")
    .required("Please enter PAN"),
  dateOfBirth: Yup.date()
    .max(moment().subtract(18, "years").toDate(), "Age should be 18 or more")
    .required("Please enter date of birth"),
  fatcaDeclaration: Yup.string().required("FATCA Declaration is required"),
  modeOfOperation: Yup.string().required("Please select mode of operation"),
  name_as_per_pan: Yup.string().required("Please enter name as per pan"),
});

// const EmailVerificationSchema = Yup.object().shape({
//   email: Yup.string().email("Invalid email").required("Please enter email"),
// });

function PAN({ activeHolder }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // const [showEmailModal, setShowEmailModal] = useState(false);
  // const [emailVerified, setEmailVerified] = useState(false);
  const [showPanInfoModal, setShowPanInfoModal] = useState(false);
  const [showDgLockerModal, setShowDgLockerModal] = useState(false);
  const [panInfo, setPanInfo] = useState(false);
  const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);

  // const [otp, setOtp] = useState("");
  const minDate = new Date("01/01/1920");
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - 18);

  const [mobileTimer, setMobileTimer] = useState({
    tried: 0,
    counter: 60,
    sendOtp: false,
  });
  const [emailTimer, setEmailTimer] = useState({
    tried: 0,
    counter: 60,
    sendOtp: false,
  });

  useEffect(() => {
    let intervalId;
    if (mobileTimer.counter > 0 && mobileTimer.sendOtp) {
      intervalId = setInterval(() => {
        setMobileTimer((prev) => ({ ...prev, counter: prev.counter - 1 }));
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [mobileTimer, mobileTimer.sendOtp]);

  useEffect(() => {
    let intervalId;
    if (emailTimer.counter > 0 && emailTimer.sendOtp) {
      intervalId = setInterval(() => {
        setEmailTimer((prev) => ({ ...prev, counter: prev.counter - 1 }));
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [emailTimer, emailTimer.sendOtp]);

  // const openEmailModal = (value) => {
  //   if (value === "Yes") {
  //     setShowEmailModal(true);
  //   }
  // };

  const handleSubmit = async (values) => {
    if (
      !allowedPEP &&
      (values.politicalExposedPerson == "PEP" ||
        values.politicalExposedPerson == "Related to PEP")
    ) {
      toast.error("PEP person not allowed, Please contact your broker.");
    } else {
      submitDataToAPI(values);
    }
  };

  const submitDataToAPI = async (values) => {
    dispatch(setReduxLoading(true));

    const portal_domain = window.sessionStorage.getItem("portal_domain");
    const API_URL = portal_domain
      ? portal_domain.substring(0, portal_domain.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };

    let formData = new FormData();

    // Append values to formData
    formData.append("pan", values.panNumber);
    formData.append(
      "dob",
      moment(values.dateOfBirth, "YYYY-MM-DD").format("DD-MM-YYYY")
    );
    formData.append("politically_expose", values.politicalExposedPerson);
    formData.append("fatca_declaration", values.fatcaDeclaration);
    formData.append("mode_of_operation", values.modeOfOperation);
    formData.append("holder", activeHolder);
    formData.append("name_as_per_pan", values.name_as_per_pan);

    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.joint_holder.pan_verification.endpoint`,
        formData,
        headers
      );
      setPanInfo(resp.data.data);
      dispatch(setReduxLoading(false));
      setShowPanInfoModal(true);
    } catch (error) {
      console.log(error);
      dispatch(setReduxLoading(false));
      const errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Something went wrong";

      toast.error(errorMessage);
    }
  };

  // useEffect(() => {
  //   if (!showEmailModal) {
  //     setIsEmailSubmitted(false);
  //   }
  // }, [showEmailModal]);

  const sendEmailToVerify = async (values, sendOtp = false) => {
    setLoading(true);
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    const API_URL = portal_domain
      ? portal_domain.substring(0, portal_domain.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    let formData = new FormData();

    // Append values to formData
    formData.append("email", values.email);
    formData.append("holder", activeHolder);
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.joint_holder.email_verification.email_otp_request`,
        formData,
        headers
      );
      console.log(resp.data);
      if (resp) {
        toast.success(resp.data.message);
      }
      if (sendOtp) {
        setEmailTimer((prev) => ({
          ...prev,
          tried: prev.tried + 1,
          counter: 60,
          sendOtp: true,
        }));
      }
      setIsEmailSubmitted(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      const { response } = error;
      toast.error(response?.data?.message || "internal server error!");
    }
  };

  const verifyEmailOTP = async (values, setFieldValue) => {
    setLoading(true);
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    const API_URL = portal_domain
      ? portal_domain.substring(0, portal_domain.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    let formData = new FormData();

    // Append values to formData
    formData.append("email", values.email);
    formData.append("holder", activeHolder);
    formData.append("otp", values.otp);
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.joint_holder.email_verification.email_otp_verification_request`,
        formData,
        headers
      );
      if (resp) {
        toast.success(resp.data.message);
        setIsEmailVerifed(true);
        setEmailTimer({
          tried: 0,
          counter: 60,
          sendOtp: false,
        });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      const { response } = error;
      console.error("Error verifying mobile OTP:", error);
      toast.error(
        response.data?.message ||
        "An error occurred during verification. Please try again."
      );
      setLoading(false);
    }
  };

  // const handleEmailSubmit = (values, setFieldValue) => {
  //   // setEmailVerified(true);
  //   if (isEmailSubmitted) {
  //     verifyEmailOTP(values, setFieldValue);
  //   } else {
  //     // setIsEmailSubmitted(true);
  //     sendEmailToVerify(values);
  //   }

  //   // setShowEmailModal(false);
  //   // Email verification logic here
  // };

  const handleSubmitModal = (value) => {
    if (value == "No") {
      setShowDgLockerModal(false);
      dispatch(getStageScreen());
    } else {
      setShowDgLockerModal(false);
      dispatch(getDgLocker());
      window.localStorage.setItem("jointHolder", activeHolder);
      //Code to move to digilocker
    }
  };

  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [isMobileOtpSent, setIsMobileOtpSent] = useState(false);
  const [emailOtp, setEmailOtp] = useState("");
  const [mobileOtp, setMobileOtp] = useState("");
  const [isMobileVerified, setIsMobileVerifed] = useState(false);
  const [isEmailVerified, setIsEmailVerifed] = useState(false);

  const verifyMobileOTP = async ({ mobileNumber, otp }) => {
    setLoading(true); // Assuming you have a setLoading state to handle loading UI
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    const API_URL = portal_domain
      ? portal_domain.substring(0, portal_domain.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };

    let formData = new FormData();
    formData.append("mobile", `91${mobileNumber}`);
    formData.append("holder", activeHolder);
    formData.append("otp", otp);

    try {
      const response = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.joint_holder.mobile_verification.mobile_otp_verification_request`,
        formData,
        headers
      );

      // Assuming the API returns a JSON response with a success status/message
      if (response.data && response.data.code == 200) {
        toast.success("Mobile number verified successfully!");
        // Perform any additional actions on successful verification
        setIsMobileOtpSent(false); // Reset the OTP sent flag or handle as needed
        setIsMobileVerifed(true);
        setMobileTimer({
          tried: 0,
          counter: 60,
          sendOtp: false,
        });
      } else {
        // Handle any specific error messages from your API
        toast.error(
          response.data.message || "Verification failed. Please try again."
        );
      }
    } catch (error) {
      // Handle general errors such as network issues
      const { response } = error;
      console.error("Error verifying mobile OTP:", error);
      toast.error(
        response.data?.message ||
        "An error occurred during verification. Please try again."
      );
    } finally {
      setLoading(false); // Ensure loading state is reset regardless of outcome
    }
  };

  useEffect(() => {
    if (emailOtp.length === 6) {
      // Assuming verifyEmailOTP function accepts email and OTP as arguments
      verifyEmailOTP({ email: email, otp: emailOtp });
    }
  }, [emailOtp]); // Add dependencies as needed

  useEffect(() => {
    if (mobileOtp.length === 6) {
      // Call your mobile OTP verification function here, similar to verifyEmailOTP
      verifyMobileOTP({ mobileNumber: mobileNumber, otp: mobileOtp });
    }
  }, [mobileOtp]); // Add dependencies as needed

  const sendMobileOtp = async (mobileNumber, sendOtp = false) => {
    setLoading(true);

    const portal_domain = window.sessionStorage.getItem("portal_domain");
    const API_URL = portal_domain
      ? portal_domain.substring(0, portal_domain.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };

    const formData = new FormData();
    formData.append("mobile", `91${mobileNumber}`);
    formData.append("holder", activeHolder);

    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.joint_holder.mobile_verification.mobile_otp_request`,
        formData,
        headers
      );
      console.log(resp.data);
      if (resp) {
        toast.success(resp.data.message);
        setLoading(false);
        setIsMobileOtpSent(true);
        if (sendOtp) {
          setMobileTimer((prev) => ({
            ...prev,
            tried: prev.tried + 1,
            counter: 60,
            sendOtp: true,
          }));
        }
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      const { response } = error;
      toast.error(response?.data?.message || "internal server error!");
    }
  };
  const [allowedPEP, setAllowedPEP] = useState(false);

  const getPEPSettings = () => {
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    axios
      .get(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.check_pep_setting`,
        headers
      )
      .then(() => {
        setAllowedPEP(true);
      })
      .catch(() => {
        setAllowedPEP(false);
      });
  };

  useEffect(() => {
    getPEPSettings();
  }, []);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  return (
    <div className="row">
      <div className="col-12 col-md-9 mb-4">
        <Title title="PAN Details" />
        <Formik
          initialValues={{
            panNumber: "",
            dateOfBirth: "",
            politicalExposedPerson: "Not PEP or not related to PEP",
            fatcaDeclaration: "1",
            modeOfOperation: "Jointly",
            email: "",
            otp: "",
            name_as_per_pan: ""
          }}
          validationSchema={MainSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, values, setFieldValue }) => {
            return (
              <Form>
                <div className="form-group">
                  <InputTitle title="PAN Number" />
                  <Field
                    name="panNumber"
                    placeholder="PAN Number"
                    className="form-control"
                    onChange={(e) => {
                      // Convert value to uppercase and update Formik's state
                      const upperValue = e.target.value.toUpperCase();
                      setFieldValue("panNumber", upperValue);
                    }}
                    style={{ maxWidth: "400px" }}
                  />
                  {errors.panNumber && touched.panNumber && (
                    <div className="text-danger">{errors.panNumber}</div>
                  )}
                </div>
                <div className="form-group">
                  <InputTitle title="Name as per PAN" />
                  <Field
                    name="name_as_per_pan"
                    placeholder="Name as per pan"
                    className="form-control"
                    onChange={(e) => {
                      // Convert value to uppercase and update Formik's state
                      const upperValue = e.target.value.toUpperCase();
                      setFieldValue("name_as_per_pan", upperValue);
                    }}
                    style={{ maxWidth: "400px" }}
                  />
                  {errors.name_as_per_pan && touched.name_as_per_pan && (
                    <div className="text-danger">{errors.name_as_per_pan}</div>
                  )}
                </div>

                <div className="form-group mt-2">
                  <InputTitle title="Date of Birth" />
                  <div style={{ maxWidth: "400px" }}>
                    <DatePicker
                      placeholderText="dd/mm/yyyy"
                      dateFormat="dd/MM/yyyy"
                      selected={values.dateOfBirth}
                      onChange={(date) => setFieldValue("dateOfBirth", date)}
                      customInput={
                        <InputMask
                          style={{ width: "100%" }}
                          mask="99/99/9999"
                        />
                      }
                      maxDate={maxDate}
                      minDate={minDate}
                      className="form-control"
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      isClearable
                    />
                    {/* <Field name="dateOfBirth" type="date" className="form-control date-input-no-before" /> */}
                  </div>
                  {errors.dateOfBirth && touched.dateOfBirth && (
                    <div className="text-danger">{errors.dateOfBirth}</div>
                  )}
                </div>
                {/* Mobile Verification */}
                <div className="form-group mt-2">
                  <InputTitle title="Mobile Number" />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <div style={{ position: "relative" }}>
                        <Field
                          name="mobileNumber"
                          type="text"
                          className="form-control"
                          placeholder="Mobile Number"

                          value={mobileNumber}
                          onChange={(e) => {
                            setFieldValue("mobileNumber", e.target.value);
                            setMobileNumber(e.target.value);
                          }}
                          disabled={isMobileVerified || mobileTimer.sendOtp}
                          maxLength="10"
                          onKeyPress={validateOnNumber}

                        />
                        {mobileNumber && !isMobileVerified && (
                          <button
                            type="button"
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0.5rem",
                              transform: "translateY(-50%)",
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setFieldValue("mobileNumber", "");
                              setMobileNumber("");
                              setIsMobileOtpSent(false);
                              setMobileTimer({
                                tried: 0,
                                counter: 60,
                                sendOtp: false,
                              });
                            }}
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </div>
                    <div>
                      {!isMobileVerified && mobileNumber.length === 10 && (
                        <>
                          {isMobileOtpSent ? (
                            <div className="mx-2 d-flex">
                              <input
                                type="text"
                                name="mobileOtp"
                                className="form-control"
                                placeholder="Enter OTP"
                                maxLength="6"
                                onChange={(e) => setMobileOtp(e.target.value)}
                                style={{ maxWidth: "400px" }}
                              />

                              <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                style={{ width: 200, border: "none" }}
                                onClick={() =>
                                  sendMobileOtp(mobileNumber, true)
                                }
                                disabled={loading || mobileTimer.counter > 0}
                              >
                                Resend OTP
                              </button>
                            </div>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-sm btn-primary"
                              style={{ marginLeft: 10, border: "none" }}
                              onClick={() => sendMobileOtp(mobileNumber, true)}
                              disabled={loading}
                            >
                              Send OTP to Verify
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  {mobileTimer.sendOtp && mobileTimer.counter > 0 && (
                    <span className="btn-sm">{`You can resend OTP in ${mobileTimer.counter} second`}</span>
                  )}
                </div>

                {/* Email Verification */}
                <div className="form-group mt-2">
                  <InputTitle title="Email Address" />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <div>
                        <Field
                          name="emailId"
                          type="email"
                          className="form-control"
                          placeholder="Email Address"
                          value={email}
                          onChange={(e) => {
                            setFieldValue("emailId", e.target.value);
                            setEmail(e.target.value);
                          }}
                          disabled={isEmailVerified || emailTimer.sendOtp}
                          style={{ maxWidth: "400px" }}
                        />
                        {email && !isEmailVerified && (
                          <button
                            type="button"
                            style={{
                              position: "absolute",
                              top: "50%",
                              right: "0.5rem",
                              transform: "translateY(-50%)",
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setFieldValue("emailId", "");
                              setEmail("");
                              setIsEmailSubmitted(false);
                              setEmailTimer({
                                tried: 0,
                                counter: 60,
                                sendOtp: false,
                              });
                            }}
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </div>
                    <div >
                      {!isEmailVerified && validateEmail(email) && (
                        <>
                          {isEmailSubmitted ? (
                            <div className="mx-2 d-flex">
                              <input
                                type="text"
                                name="emailOtp"
                                className="form-control"
                                placeholder="Enter OTP"
                                maxLength="6"
                                onChange={(e) => setEmailOtp(e.target.value)}
                                style={{ maxWidth: "400px" }}
                              />

                              <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                style={{ width: 200, border: "none" }}
                                onClick={() =>
                                  sendEmailToVerify({ email: email }, true)
                                }
                                disabled={loading || emailTimer.counter > 0}
                              >
                                Resend OTP
                              </button>
                            </div>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-sm btn-primary"
                              style={{ marginLeft: 10, border: "none" }}
                              onClick={() =>
                                sendEmailToVerify({ email: email }, true)
                              }
                              disabled={loading}
                            >
                              Send OTP to Verify
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  {emailTimer.sendOtp && emailTimer.counter > 0 && (
                    <div className="btn-sm">{`You can resend OTP in ${emailTimer.counter} second`}</div>
                  )}
                </div>

                <div className="form-group mt-3">
                  <div>
                    <InputTitle title="Politically Exposed (PEP) Declaration" />
                    {/* <label className="form-check-label">
                      <strong>Politically Exposed (PEP) Declaration</strong>
                    </label> */}
                  </div>

                  <div className="form-check-inline">
                    <label className="form-check-label">
                      <Field
                        type="radio"
                        name="politicalExposedPerson"
                        value="Not PEP or not related to PEP"
                      />
                      &nbsp;Not PEP or not related to PEP
                    </label>
                  </div>
                  <div className="form-check-inline">
                    <label className="form-check-label">
                      <Field
                        type="radio"
                        name="politicalExposedPerson"
                        value="PEP"
                      />
                      &nbsp;PEP
                    </label>
                  </div>
                  <div className="form-check-inline">
                    <label className="form-check-label">
                      <Field
                        type="radio"
                        name="politicalExposedPerson"
                        value="Related to PEP"
                      />
                      &nbsp;Related to PEP
                    </label>
                  </div>
                </div>

                <div className="form-group mt-3">
                  <div>
                    {/* <label className="form-check-label">
                      <strong>FATCA Declaration</strong>
                    </label> */}
                    <InputTitle title="FATCA Declaration" />
                  </div>
                  <div className="form-check-inline">
                    <label className="form-check-label">
                      <Field
                        type="radio"
                        name="fatcaDeclaration"
                        value="1"
                      />
                      &nbsp;Not Covered under FATCA
                    </label>
                  </div>
                  <div className="form-check-inline">
                    <label className="form-check-label">
                      <Field
                        type="radio"
                        name="fatcaDeclaration"
                        value="0"
                      />
                      &nbsp;Covered under FATCA
                    </label>
                  </div>
                  {errors.fatcaDeclaration && touched.fatcaDeclaration && (
                    <div className="text-danger">{errors.fatcaDeclaration}</div>
                  )}
                </div>

                <Button
                  type="submit"
                  className="btn btn-primary mt-3"
                  disabled={!isMobileVerified || !isEmailVerified}
                  title="Submit"
                >
                  Submit
                </Button>
              </Form>
            );
          }}
        </Formik>

        {/* Show PAN Info */}
        <Modal show={showPanInfoModal}>
          <Modal.Header>
            <Modal.Title>Name as per PAN</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>
              Do you want to proceed with <strong>{panInfo?.full_name}</strong>
            </h6>
          </Modal.Body>
          <Modal.Footer>
            <Button
              title="Proceed"
              handleClick={() => {
                setShowPanInfoModal(false);
                setShowDgLockerModal(true);
              }}
            />
            <Button
              title="Cancel"
              handleClick={() => setShowPanInfoModal(false)}
            />
          </Modal.Footer>
        </Modal>
        {/* DIGILocker modal */}
        <Modal show={showDgLockerModal}>
          <Modal.Header>
            <Modal.Title>Continue with DigiLocker</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h6>Do you want to proceed with digilocker?</h6>
          </Modal.Body>
          <Modal.Footer>
            <Button
              title="No, I upload manually"
              handleClick={() => handleSubmitModal("No")}
            />
            <Button
              title="Yes"
              handleClick={() => handleSubmitModal("Yes")}
            />
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default PAN;
